export const LOGO_HEADER_URL =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/logo-company/logo-adamftd-header.webp';
export const LOGO_LOGIN_URL =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/logo-company/logo-adamftd-login.webp';
export const LOGO_WHITE_URL =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/logo-company/logo-adamftd-white.webp';
export const LOGO_INVOICE_URL =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/logo-company/logo-invoice.svg';
export const LOGO_COMPANY_DEFAULT_URL =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/logo-company/logo-company-default.svg';
export const LOGO_GOOGLE_URL =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/logo-social/google.png';
export const LOGO_TRUSTPILOT_URL =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/logo-social/trustpilot.png';
export const LOGO_YELP_URL =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/logo-social/yelp.png';
export const BACKGROUND_LOGIN =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/background-login.webp';
export const BANNER_NOTIFY_HOME_PAGE =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/banner-notify-home-page.webp';
export const ICON_BANNER_HOME_PAGE =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-banner-home-page.webp';
export const ICON_SUPPORT_NO_DATA_COMPANY =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-support-no-data-company.webp';
export const ICON_QUICK_TIP_SEARCH_COMPANY =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-quick-tips-search-company.webp';
export const ICON_NO_MATCH_SEARCH_COMPANY =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-no-matching-search-company.webp';
export const ICON_NO_DATA_COMPANY =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-no-data-company.webp';
export const ICON_NO_PLAN_AND_USAGE =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-no-plan-and-usage.webp';
export const ICON_DISCLAIMER_COMPANY_DATA =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-disclaimer-company-data.webp';
export const ICON_PAID_TO_UNBLOCK_CONTENT =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-paid-to-unblock-content.webp';
export const ICON_DO_NOT_HAVE_ENOUGH_CREDIT =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-do-not-have-enough-credit.webp';
export const ICON_UPGRADE_PLAN =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-upgrade-plan.webp';
export const ICON_CONFIRM_GET_TRIAL =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-confirm-get-trial.webp';
export const ICON_WALLET_PRICING_PLAN =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-wallet-pricing-plan.webp';
export const BANNER_BOOKING_DEMO_CALENDAR =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/banner-booking-demo-calendar.webp';
export const ICON_PROMOTION_CAMPAIGN =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-promotion-campaign.webp';
export const ICON_GIFT_CAMPAIGN =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-gift-campaign.webp';
export const ICON_SPECIAL_GIFT =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-special-gift.webp';
export const ICON_WARNING_ACTION =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-warning-action.webp';
export const ICON_GIFT_SPECIAL_PLAN =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-gift-special-plan.webp';
export const ICON_SUPPLEMENT_RECORDS_DATA =
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/icons/icon-supplement-records-data.png';

export const DEFAULT_AVATARS = [
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/avatar-user-default/avatar1.webp',
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/avatar-user-default/avatar2.webp',
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/avatar-user-default/avatar3.webp',
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/avatar-user-default/avatar4.webp',
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/avatar-user-default/avatar5.webp',
  'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/avatar-user-default/avatar6.webp',
  // "https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/avatar-user-default/avatar7.webp",
  // "https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/avatar-user-default/avatar8.webp",
  // "https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/avatar-user-default/avatar9.webp",
  // "https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/avatar-user-default/avatar10.webp",
  // "https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/avatar-user-default/avatar11.webp",
  // "https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/avatar-user-default/avatar12.webp"
] as Array<string>;

export const TARIFFS_AND_RULE_DEFAULT_PAGE_IMAGES = {
  shipping_blue_box:
    'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/tariffs-and-rules-page/shipping_blue_box.webp',
  avoid_costly_penalties:
    'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/tariffs-and-rules-page/avoid_costly_penalties.webp',
  optimize_market_entry:
    'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/tariffs-and-rules-page/optimize_market_entry.webp',
  enhance_supply_chain_efficiency:
    'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/tariffs-and-rules-page/enhance_supply_chain_efficiency.webp',
  international_money_transfer:
    'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/tariffs-and-rules-page/international-money-transfer.webp',
  saving_money_bank:
    'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/tariffs-and-rules-page/saving-money-bank.webp',
  supply_chain_distribution:
    'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/tariffs-and-rules-page/supply-chain-distribution.webp',
  us_tariff_banner:
    'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/tariffs-and-rules-page/us-tariff-banner.webp',
};

export const AI_HS_CODE_LABELING_IMAGES = {
  banner:
    'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/ai-hs-code-labeling/hs-code-labeling-banner.webp',
  banner_widget:
    'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/ai-hs-code-labeling/hs-code-labeling-widget.webp',
  single_prediction_cover:
    'https://pub-4b6f0902723449af8d7f40fbc8af7b01.r2.dev/front-end/images/ai-hs-code-labeling/single-prediction-cover.webp',
};
